module.exports = __webpack_public_path__ + "static/media/chat.95872615.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chat.svg
// module id = 1414
// module chunks = 0